export default __webpack_public_path__ + "static/media/IMG_HOME_NOTICIAS.b31bb6d2.png";